import { useLocation, useHistory } from "react-router-dom";
export var useHideUpdateCartModal = function() {
    var location = useLocation();
    var history = useHistory();
    if (history.length > 1) {
        return function() {
            return history.goBack();
        };
    }
    return function() {
        var searchParams = new URLSearchParams(location.search);
        searchParams.delete("product");
        searchParams.delete("findByToken");
        searchParams.delete("updateQuantityOnChange");
        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };
};
